/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Evaluationid2Inputs */

const de__field_evaluationid2 = /** @type {(inputs: _Field_Evaluationid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluation-ID`)
};

/**

* @param {_Field_Evaluationid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_evaluationid2 = /** @type {((inputs?: _Field_Evaluationid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Evaluationid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_evaluationid2(inputs)
});
export { _field_evaluationid2 as "_field_evaluationID" }